<app-modal-frame
  [headerText]="CONSTANTS.ADD_GROUP"
  [leftButton]="{
    text: CONSTANTS.RESET,
    imageSrc: '',
    type: BUTTON_TYPES.CANCEL_BUTTON,
    disable: false,
  }"
  [rightButton]="{
    text: CONSTANTS.ADD,
    disable: groupForm.invalid,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  (emitExit)="onClose()"
  (emitLeftClick)="onReset()"
  (emitRightClick)="onSubmit()"
>
  <ion-row class="add-group-form-container">
    <ion-col size="9" class="group-code-container">
      <app-form-text-field
        [labelText]="CONSTANTS.ADD_GROUP"
        [placeholderText]="CONSTANTS.GROUP_CODE_PLACEHOLDER"
        [form]="groupForm"
        [control]="'groupCode'"
        [maxLength]="10"
        [autoCapitalizeCharacters]="true"
        [regexType]="REGEX"
      ></app-form-text-field>
    </ion-col>
    <ion-col size="9" class="description-container">
      <app-form-text-field
        [labelText]="CONSTANTS.DESCRIPTION"
        [placeholderText]="CONSTANTS.DESCRIPTION_PLACEHOLDER"
        [form]="groupForm"
        [control]="'description'"
        [maxLength]="30"
        [regexType]="REGEX"
      ></app-form-text-field>
    </ion-col>
  </ion-row>
</app-modal-frame>
